export default __webpack_public_path__ + "static/media/Green Visa - Benefits.1e449a56.jpg";